import { SearchIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Spinner,
  VStack,
} from "@chakra-ui/react";
import { ConfirmAction, PerformerRow } from "./PerformerRow";
import { useState } from "react";
import { Performer } from "./LineupSection";

const AddArtistInput = ({
  onSearch,
  searchResults,
  onConfirm,
  isLoading = false,
  isDisabled = false,
}: {
  onSearch: (query: string) => Promise<void>;
  onConfirm: ({
    name,
    image_url,
    soundcharts_id,
  }: {
    name: string;
    image_url: string;
    soundcharts_id: string;
  }) => Promise<void>;
  searchResults: Performer[];
  isLoading?: boolean;
  isDisabled?: boolean;
}) => {
  const [query, setQuery] = useState("");
  const [showMore, setShowMore] = useState(false);
  const showShowMoreButton = searchResults.length > 5;
  return (
    <VStack w="full">
      <InputGroup size="lg">
        <Input
          placeholder="Search for the performer name to add to the line-up"
          size="lg"
          outline={"1px solid gray.200"}
          borderRadius="lg"
          borderTopRightRadius={"lg"}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSearch(query);
            }
          }}
          value={query}
          borderBottomRightRadius={"lg"}
          onChange={(e) => setQuery(e.target.value)}
          isDisabled={isLoading || isDisabled}
        />
        <InputRightElement>
          {isLoading ? (
            <Spinner />
          ) : (
            <IconButton
              onClick={() => onSearch(query)}
              isDisabled={isDisabled || !query}
              borderTopLeftRadius={0}
              borderBottomLeftRadius={0}
              size="lg"
              borderRadius="lg"
              icon={<SearchIcon color="gray.600" />}
              aria-label="Search"
            />
          )}
        </InputRightElement>
      </InputGroup>
      <VStack mb={6} w="full" justifyContent="flex-start">
        {searchResults.slice(0, showMore ? 10 : 5).map(
          (s) =>
            s && (
              <Box
                key={s.id}
                p={2}
                borderColor="gray.100"
                borderWidth={1}
                w="full"
                borderRadius="xl"
              >
                <PerformerRow
                  platforms={s.profiles}
                  name={s.name}
                  id={s.id}
                  image={s.image_url}
                  actions={[
                    <ConfirmAction
                      name={"Confirm"}
                      key="confirm"
                      onClick={() => {
                        onConfirm({
                          name: s.name,
                          image_url: s.image_url,
                          soundcharts_id: s.soundcharts_id,
                        });
                        setQuery("");
                      }}
                    />,
                  ]}
                />
              </Box>
            )
        )}
        {showShowMoreButton ? (
          <Button onClick={() => setShowMore(!showMore)}>
            Show {showMore ? "less" : "more"}
          </Button>
        ) : null}
      </VStack>
    </VStack>
  );
};
export default AddArtistInput;
